import { fetcher } from 'src/config/request';
import { MentorshipEndpoints } from './endpoints';
export const MentorshipService = {
    async getMentorship(mentorshipId) {
        const { data } = await fetcher.get(MentorshipEndpoints.getMentorship(mentorshipId));
        return data;
    },
    async createMentorship(payload) {
        const { data } = await fetcher.post(MentorshipEndpoints.createMentorship(), payload);
        return data;
    },
    async updateMentorship(mentorshipId, payload) {
        const { data } = await fetcher.put(MentorshipEndpoints.updateMentorship(mentorshipId), payload);
        return data;
    }
};
